export enum MonitoringType {
  Performance = 'performance',
  Anomaly = 'anomaly',
}

export enum MonitoringEntity {
  Site = 'site',
  Sector = 'sector',
}

export enum GeojsonFeatureKind {
  Point = 'point',
  Boundary = 'boundary',
}

export enum FilterPresetType {
  Filters = 'filters',
  Period = 'period',
  Ranges = 'ranges',
  MapLegends = 'mapLegends',
}

export enum StatusKind {
  WarningAndAlert = 'warningAndAlert',
  Warning = 'warning',
  Alert = 'alert',
  DeadlineMissed = 'deadlineMissed',
}
